import type { Country } from '@seek/melways-sites';

export const getAgeLimit = (locale: Country) => {
  switch (locale) {
    case 'sg':
      return 13;
    case 'th':
      return 20;
    case 'id':
      return 21;
    default:
      return 18;
  }
};
